import plugin from 'tailwindcss/plugin';

export const startingStyle = plugin(({ addVariant }) => {
  addVariant('starting', '@starting-style');
});
